module.exports = __webpack_public_path__ + "img/mm-cal.133a9447.svg";